import { Injectable , Inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../environments/environment';
import { SharedService } from '../modules/shared/service/shared.service';
import { isPlatformBrowser } from '@angular/common';
import { ReplaySubject } from 'rxjs';
import Swal from 'sweetalert2';
import { TextSetting } from '../textsetting';
@Injectable()

export class CommonFunctionsService {
	// Define valiables
	private isBrowserSubject = new ReplaySubject<boolean>(0);
	public isBrowser	= this.isBrowserSubject.asObservable();
	env				=	environment;
	SITE_API_URL:	any	=	'';
	data:	any	=	{};

	// Define constructor
	constructor(public sharedService: SharedService, @Inject(PLATFORM_ID) private platformId: object){
		if (isPlatformBrowser(this.platformId)){
			this.isBrowserSubject.next(true);
		}
		this.SITE_API_URL	=	this.env.API_URL;
	}

	// This function is used for geting data from localstorage
	getItem = (key:any): any=>{
		if(this.isBrowser){
			let data = localStorage.getItem(key);
			return data;
		}
	}

	// This function is used for setting data from localstorage
	public setItem(key:any,item:any): any{
		if(this.isBrowser){
			localStorage.setItem(key,item);
			return ;
		}
	}

	// This function is used to remove data from localstorage
	public removeItem(key:any): any{
		if(this.isBrowser){
			localStorage.removeItem(key);
			return ;
		}
	}

	
    // This function is used to open confirm box
	public confirm(modal_text:any):any{
		return Swal.fire({
			title: TextSetting.ARE_YOU_SURE,
			text: modal_text,
			icon: 'warning',
			showCancelButton: true,
			cancelButtonText: TextSetting.CANCEL,
			confirmButtonText: TextSetting.OK
		}).then((result:any) => {
			if (result.value) {
				return result.isConfirmed;
			} else if (result.dismiss === Swal.DismissReason.cancel) {
				return result.isConfirmed;
			}
		})
	}



	// Function used to get user data/
	updateCurrentUserData = (slug: any): any => {
		const methodName			=	'get_user_detail';
		const methodUrl				=	environment.API_URL + methodName;
		this.data					=	{};
		this.data.data				=	{};
		this.data.data.user_slug			=	slug;
		return this.sharedService.getPost(methodUrl, this.data);
	}


	// Function used to puchase subscription plan/
	makePayment = (formData: any): any => {
		const methodName			=	'purchase_subscription_plan';
		const methodUrl				=	environment.API_URL + methodName;
		this.data					=	{};
		this.data.data				=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}
	// Function used to purchase resume writer services/
	makeResumePayment = (formData: any): any => {
		const methodName			=	'purchase_resume_writer_service';
		const methodUrl				=	environment.API_URL + methodName;
		this.data					=	{};
		this.data.data				=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}
	// Function used to purchase resume templates/
	purchaseResumeTemplate = (formData: any): any => {
		const methodName			=	'purchase_resume_template';
		const methodUrl				=	environment.API_URL + methodName;
		this.data					=	{};
		this.data.data				=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}
	// Function used to get global settings/
	getGlobalSettings = (): any => {
		const methodName			=	'get_global_settings';
		const methodUrl				=	environment.API_URL + methodName;
		this.data					=	{};
		this.data.data				=	{};
		return this.sharedService.getPost(methodUrl, this.data);
	}

	// This function is used to scroll on top 
	public scrollTop(): void {
		if(this.isBrowser){
			window.scrollTo(0, 0);
		}
	}

	// Function used to change mobile number
	submitUpdatePhoneForm = (formData: any): any => {
		const methodName			=	'change_mobile_number';
		const methodUrl				=	environment.API_URL + methodName;
		this.data					=	{};
		this.data.data				=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}
	// Function used for submit mobile number otp
	submitPhoneOtp = (formData: any): any => {
		const methodName			=	'verify_change_mobile_otp';
		const methodUrl				=	environment.API_URL + methodName;
		this.data					=	{};
		this.data.data				=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}

	// Function used for submit mobile number otp
	submitResume = (formData: any): any => {
		const methodName			=	'upload_resume';
		const methodUrl				=	environment.API_URL + methodName;
		this.data					=	{};
		this.data.data				=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}

	// Function used for submit mobile number otp
	signedUrl = (formData: any): any => {
		const methodName			=	'get_signed_url';
		const methodUrl				=	environment.API_URL + methodName;
		this.data					=	{};
		this.data.data				=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}

	generatesignedUrl = (formData: any): any => {
		const methodName			=	'get_generate_signed_url';
		const methodUrl				=	environment.API_URL + methodName;
		this.data					=	{};
		this.data.data				=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}

	// Function used for get user data for resume
	getUserResumeData = (formData: any): any => {
		const methodName			=	'get_user_detail_template_wise';
		const methodUrl				=	environment.API_URL + methodName;
		this.data					=	{};
		this.data.data				=	formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}

}
